/**
 * Filter Enums for Sessions Report
 * Based on Flutter EnergyFlutter implementation
 */

/**
 * Location Usage Types
 * Maps to machineUsage field in API
 */
export const LocationUsage = {
  Public: 'Public',
  SemiPublic: 'SemiPublic',
  PrivateHouse: 'PrivateHouse',
  SharedBuilding: 'SharedBuilding',
} as const;

export type LocationUsageType = (typeof LocationUsage)[keyof typeof LocationUsage];

export const LocationUsageLabels: Record<LocationUsageType, string> = {
  Public: 'Public',
  SemiPublic: 'Semi Public',
  PrivateHouse: 'Private House',
  SharedBuilding: 'Shared Building',
};

/**
 * Start Source Types
 * Maps to startSource field in API
 */
export const StartSource = {
  AccountCard: 'AccountCard',
  AccountExternal: 'AccountExternal',
  CardPresent: 'CardPresent',
  Ocpi: 'Ocpi',
  Spark: 'Spark',
  Generated: 'Generated',
  Dcs: 'Dcs',
  ThirdPartyOcpp: 'ThirdPartyOcpp',
  UndefinedToken: 'UndefinedToken',
  UnrecognizedToken: 'UnrecognizedToken',
} as const;

export type StartSourceType = (typeof StartSource)[keyof typeof StartSource];

export const StartSourceLabels: Record<StartSourceType, string> = {
  AccountCard: 'Account Card',
  AccountExternal: 'Account External',
  CardPresent: 'Card Present',
  Ocpi: 'OCPI',
  Spark: 'Spark',
  Generated: 'Generated',
  Dcs: 'DCS',
  ThirdPartyOcpp: 'Third Party OCPP',
  UndefinedToken: 'Undefined Token',
  UnrecognizedToken: 'Unrecognized Token',
};

/**
 * Card Types (Payment Methods)
 * Maps to cardType field in API
 * Simplified to Credit Card and RFID per HIVE-6307
 */
export const CardType = {
  CreditCard: 'CreditCard',
  Rfid: 'Rfid',
} as const;

export type CardTypeValue = (typeof CardType)[keyof typeof CardType];

export const CardTypeLabels: Record<CardTypeValue, string> = {
  CreditCard: 'Credit Card',
  Rfid: 'RFID',
};

/**
 * Session Health Status
 * Used for filtering active/completed sessions
 */
export const SessionHealth = {
  All: 'all',
  Completed: 'completed',
  Active: 'active',
} as const;

export type SessionHealthType = (typeof SessionHealth)[keyof typeof SessionHealth];

export const SessionHealthLabels: Record<SessionHealthType, string> = {
  all: 'All Sessions',
  completed: 'Completed',
  active: 'Active (In Progress)',
};

/**
 * Device Type Filter - Predefined Options
 * Common device types shown as quick-select options
 * Users can also enter custom device types not in this list
 */
export const COMMON_DEVICE_TYPES = ['Amit', 'ONYX', 'VPOS Touch', 'VPOSM', 'VPOSM4 Mini'] as const;

export const DeviceTypeLabels: Record<string, string> = {
  Amit: 'Amit',
  ONYX: 'ONYX',
  'VPOS Touch': 'VPOS Touch',
  VPOSM: 'VPOSM',
  'VPOSM4 Mini': 'VPOSM4 Mini',
};
